import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { Capacitor } from '@capacitor/core';
import { testConfig } from "./config";
import { getLogger } from "./logger";

const logger = getLogger('haptics');

const hapticsEnabled = (!testConfig.isTestEnv || process.env.NEXT_PUBLIC_HAPTICS_MODE === 'enabled') && Capacitor.isNativePlatform();

// Haptics are best-effort feedback: failures should never surface to the caller or become an
// unhandled rejection. Each helper swallows and logs its own errors so call sites can just
// fire-and-forget without a .catch().
async function runHaptic(label: string, fn: () => void | Promise<void>) {
    try {
        await fn();
    } catch (err) {
        logger.error(`${label} failed: ${err instanceof Error ? err.message : JSON.stringify(err)}`);
    }
}

export function fireMediumHaptic() {
    return runHaptic('fireMediumHaptic', () => {
        if (hapticsEnabled) {
            return Haptics.impact({ style: ImpactStyle.Medium });
        } else if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
            navigator.vibrate(200);
        }
        return undefined;
    });
}

export function hapticLightVibration() {
    return runHaptic('hapticLightVibration', () => {
        if (hapticsEnabled) {
            return Haptics.impact({ style: ImpactStyle.Light });
        } else if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
            navigator.vibrate(100);
        }
        return undefined;
    });
}

export function errorHaptic() {
    return runHaptic('errorHaptic', () => {
        if (hapticsEnabled) {
            return Haptics.notification({ type: NotificationType.Error });
        } else if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
            navigator.vibrate([ 200, 100, 200 ]);
        }
        return undefined;
    });
}
